import { useMemo } from 'react';

import { useProfile } from 'context/profile';
import Profile, { PRODUCT_ACCESSORS } from 'models/Profile';

const getDefaultRedirect = (profile: Profile) => {
  const careCoordinationEnabled = profile.has(PRODUCT_ACCESSORS.careCoordinationEnabled);
  const olioSummarizationEnabled = profile.has(PRODUCT_ACCESSORS.olioSummarizationEnabled);

  if (olioSummarizationEnabled && !careCoordinationEnabled) {
    return '/summarizations/new';
  }

  return careCoordinationEnabled ? '/patients' : '/error';
};

export default function useDefaultRedirect() {
  const { profile } = useProfile();

  const redirectTo = useMemo(() => getDefaultRedirect(profile), [profile]);

  return redirectTo;
}
